import React from 'react';
import styles from './TextPlaceholder.scss';
import { Text } from 'wix-style-react';

export default function TextPlaceholder({ className, isLoading, ...rest }) {
  if (isLoading) {
    return <Text {...rest} className={`${className} ${styles.isLoading}`} />;
  } else {
    return <Text {...rest} />;
  }
}

TextPlaceholder.displayName = 'TextPlaceholder';
